import { observer } from 'mobx-react-lite';
import React from 'react';
import { colors } from '../../../../../../../colorVars';
import { useAlertsStore } from '../../../../../../../stores/websocketStore/_alertsStore';
import { Body3 } from '../../../../../../atomic/text/Text';

export const FTFCFilter = observer(({ alertId }) => {
  const check = '✅ ';
  const x = '❌ ';
  const alertStore = useAlertsStore();
  const sortingDetails = alertStore.alertSortingStore[alertId] ?? null;
  if (!sortingDetails)
    return (
      <td>
        <Body3 fontWeight={500} color={colors.lightGrey}>
          None
        </Body3>
      </td>
    );
  const filters = sortingDetails.filters ?? null;
  if (!filters)
    return (
      <td>
        <Body3 fontWeight={500} color={colors.lightGrey}>
          None
        </Body3>
      </td>
    );
  const ftfcData = filters.FTFC_FILTER ?? null;
  if (!ftfcData)
    return (
      <td>
        <Body3 fontWeight={500} color={colors.lightGrey}>
          None
        </Body3>
      </td>
    );
  const timeFrames = ftfcData.details.timeFrameArray;
  const title = `[${timeFrames.toString()}]`;
  const truncatedTimeFrames =
    timeFrames.length > 3
      ? timeFrames.slice(0, 3).toString() + '...'
      : timeFrames.toString();
  if (ftfcData.details.bothDirections)
    return (
      <td title={title}>
        <Body3
          fontWeight={500}
          color={ftfcData.status ? colors.green : colors.red}
        >
          {ftfcData.status
            ? `${check}\u00A0 [${truncatedTimeFrames}]`
            : `${x}\u00A0 [${truncatedTimeFrames}]`}
        </Body3>
      </td>
    );
  return (
    <td title={title}>
      <Body3
        fontWeight={500}
        color={ftfcData.status ? colors.green : colors.red}
      >
        {ftfcData.status
          ? `${check}\u00A0 [${truncatedTimeFrames}]`
          : `${x}\u00A0 [${truncatedTimeFrames}]`}
      </Body3>
    </td>
  );
});
